import { TemplateData, TemplateParams } from '.';

const courseDeadlinePassed = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'courses',
  email: {
    buttonEnabled: true,
    buttonLink: '{{courseUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.courseDeadlinePassed}.
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.pathCourseDeadlineSubjectPassed}`
  },
  placeholders: {
    courseTitle: {
      label: messages.coursesCourseTitle,
      example: 'Test course'
    },
    courseUrl: {
      label: messages.commonCourseLink,
      example: `${serverConfig.adminUrl}/courses/test-course`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCourseDeadlinePassed
});

export default courseDeadlinePassed;
